import {PricingConfig} from '@flexinet/pricing-components';
import {stage} from './stage.ts';

const platformApi: PricingConfig['platformApi'] = {
    prod: {
        endpoint: 'https://jerup2o5nzej3hnn2sdv3ejtca.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: 'f2bfbc00-3e46-4327-9998-7ec47fd6e36c',
    },
    test: {
        endpoint: 'https://thz4u5ksajh6blvulnhiiddudi.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
    },
    dev: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: '688679a2-2983-4299-b7e6-ec87fb538c24',
    },
    ide: {
        endpoint: 'https://4wbjzuqnxbfobbgd2bo4mjbj5e.appsync-api.us-west-2.amazonaws.com/graphql',
        region: 'us-west-2',
        applicationId: '688679a2-2983-4299-b7e6-ec87fb538c24',
    },
};

export const publicPricingConfig: PricingConfig = {
    stage: stage,
    authMode: 'iam',
    pricingPageTitle: 'Flexi Bot Service Plans',
    pricingPageSmallScript: 'Please note that these prices are subject to change. Actual prices may vary',
    platformApi,
};

export const authenticatedPricingConfig: PricingConfig = {
    stage: stage,
    authMode: 'userPool',
    pricingPageTitle: 'Flexi Bot Service Plans',
    pricingPageSmallScript: 'Please note that these prices are subject to change. Actual prices may vary',
    platformApi,
};
